import React from "react";
import useLogin from "hooks/useLogin";

import {makeStyles} from '@material-ui/core/styles';

import loginImg from "assets/img/btn_google_signin_light_normal_web@2x.png"

const useStyles = makeStyles(theme => ({
    login: {
        background: "#71DDC6",
        position: "fixed",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    button: {
        display: 'block'
    }
}));

export default function Top() {
    const loginHook = useLogin();
    const classes = useStyles();

    // useEffect(()=> {
    // }, []);

    window.document.title = `管理システム - ログイン`;

    const login = (e) => {
        e.preventDefault();
        loginHook.login();
    };

    const testlogin = (e) => {
        e.preventDefault();
        loginHook.testlogin();
    };

    return(
        <div className={classes.login}>
            <div>
                <a className={classes.button} href="/#" onClick={e=> login(e)}>
                    <img src={loginImg} alt=""/>
                </a>
            </div>
        </div>
    )
}
